import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-notebook-dialog',
  template: `
  <h1 mat-dialog-title>Rename Notebook</h1>

  <div mat-dialog-content class="content">
    <mat-form-field class="pl-3 pr-3">
      <mat-label>Notebook name</mat-label>
      <input matInput [(ngModel)]="data" cdkFocusInitial/>
    </mat-form-field>
   </div>

  <mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button [mat-dialog-close]="data">Update</button>
  </mat-dialog-actions>
  `,
  styleUrls: ['./dialog.scss']
})
export class EditNotebookDialogComponent implements OnInit {

  //data: string;

  constructor(
    public dialogRef: MatDialogRef<EditNotebookDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
